import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCheckCircle, faStar, faRobot, faCircle, faPhoneSlash, faClock, faAngry, faRocket, faBoltLightning, faBolt, faChartLine, faComment, faComments } from '@fortawesome/free-solid-svg-icons';
import '../../styles/logistic/LogisticHero.css'; // Import the specific CSS for the hero
import { useTranslation } from "react-i18next";

const LogisticHero = () => {
  const { t } = useTranslation();
  return (
    <section className="logistic-hero">
      <div className="logistic-container logistic-hero-content">
        <div className="logistic-hero-text">
          <div className="logistic-badge-new">
            <span data-i18n="hero_badge">{t("LogisticHero:hero_badge")}</span>
          </div>
          <h1 className="logistic-hero-title">
            <span className="logistic-highlight" data-i18n="hero_title_highlight">{t("LogisticHero:hero_title_highlight")}</span> <span data-i18n="hero_title_rest">{t("LogisticHero:hero_title_rest")}</span>
          </h1>
          <p className="logistic-hero-subtitle" data-i18n="hero_subtitle">
            {t("LogisticHero:hero_subtitle")}
          </p>
          <div className="logistic-pain-points">
            <div className="logistic-pain-item">
              <FontAwesomeIcon icon={faPhoneSlash} />
              <span data-i18n="hero_pain_1">{t("LogisticHero:hero_pain_1")}</span>
            </div>
            <div className="logistic-pain-item">
              <FontAwesomeIcon icon={faClock} /> {t("LogisticHero:hero_pain_2")}
            </div>
            <div className="logistic-pain-item">
              <FontAwesomeIcon icon={faAngry} /> {t("LogisticHero:hero_pain_3")}
            </div>
          </div>
          <div className="logistic-hero-cta">
            <a href="#contact" className="logistic-btn-primary logistic-pulse">
              <FontAwesomeIcon icon={faRocket} /> {t("LogisticHero:cta_button")}
            </a>
            <div className="logistic-trust-badges">
              <div className="logistic-trust-item">
                <FontAwesomeIcon icon={faCheckCircle} /> {t("LogisticHero:trust_badge_1")}
              </div>
              <div className="logistic-trust-item">
                <FontAwesomeIcon icon={faCheckCircle} /> {t("LogisticHero:trust_badge_2")}
              </div>
            </div>
          </div>
          <div className="logistic-social-proof">
            <div className="logistic-avatars">
              <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Avatar 1" />
              <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="Avatar 2" />
              <img src="https://randomuser.me/api/portraits/men/45.jpg" alt="Avatar 3" />
            </div>
            <div className="logistic-social-text">
              <div className="logistic-stars">
                <FontAwesomeIcon icon={faStar} /><FontAwesomeIcon icon={faStar} /><FontAwesomeIcon icon={faStar} /><FontAwesomeIcon icon={faStar} /><FontAwesomeIcon icon={faStar} />
              </div>
              {t("LogisticHero:social_proof_text")}
            </div>
          </div>
        </div>
        <div className="logistic-hero-visual">
          <div className="logistic-chat-demo">
            <div className="logistic-chat-header">
              <div className="logistic-chat-avatar">
                <FontAwesomeIcon icon={faRobot} />
              </div>
              <div className="logistic-chat-info">
                <h4>{t("LogisticHero:chat_header")}</h4>
                <span className="logistic-status-online">
                  <FontAwesomeIcon icon={faCircle} /> {t("LogisticHero:chat_status")}
                </span>
              </div>
            </div>
            <div className="logistic-chat-messages">
              <div className="logistic-message logistic-bot-message">
                <p>{t("LogisticHero:bot_message_1")}</p>
                <span className="logistic-time">10:00 AM</span>
              </div>
              <div className="logistic-message logistic-user-message">
                <p>{t("LogisticHero:user_message_1")}</p>
                <span className="logistic-time">10:01 AM</span>
              </div>
              <div className="logistic-message logistic-bot-message">
                <p>{t("LogisticHero:bot_message_2")}</p>
                <span className="logistic-time">10:02 AM</span>
              </div>
              <div className="logistic-chat-options">
                <div className="logistic-chat-option">{t("LogisticHero:chat_option_1")}</div>
                <div className="logistic-chat-option">{t("LogisticHero:chat_option_2")}</div>
                <div className="logistic-chat-option">{t("LogisticHero:chat_option_3")}</div>
              </div>
            </div>
            <div className="logistic-chat-typing">
            </div>
          </div>
          <div className="logistic-floating-stat logistic-stat-1">
            <div className="logistic-chat-icons">
              <FontAwesomeIcon icon={faBolt}/>
            </div>
            <div>
              <strong>{t("LogisticHero:stat_1_value")}</strong>
              <span>{t("LogisticHero:stat_1_label")}</span>
            </div>
          </div>
          <div className="logistic-floating-stat logistic-stat-2">
            <div className="logistic-chat-icons">
              <FontAwesomeIcon icon={faChartLine}/>
            </div>
            <div>
              <strong>{t("LogisticHero:stat_2_value")}</strong>
              <span>{t("LogisticHero:stat_2_label")}</span>
            </div>
          </div>
          <div className="logistic-floating-stat logistic-stat-3">
            <div className="logistic-chat-icons">
              <FontAwesomeIcon icon={faComments}/>
            </div>
            <div>
              <strong>{t("LogisticHero:stat_3_value")}</strong>
              <span>{t("LogisticHero:stat_3_label")}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="logistic-hero-wave"></div>
    </section>
  );
};

export default LogisticHero;